import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const SummarySection = ({
  buttonText,
  buttonLink,
  buttonDisabled,
  onSubmit,
  buttonLoading,
  paymentLoading,
}) => {
  const history = useHistory();
  const cartSummary = useSelector((state) => state.cart.summary);
  const cartProps = useSelector((state) => state.cart.otherProperties);

  const handleSubmitClicked = () => {
    if (onSubmit) {
      onSubmit();
    } else {
      history.push(buttonLink);
    }
  };

  if (cartSummary) {
    const { totalcountEachProduct, totalPrice, taxedTotalPrice } = cartSummary;

    let finalButtonText = buttonText;

    if (buttonLoading) {
      finalButtonText = 'Loading ';
    }

    if (paymentLoading) {
      finalButtonText = 'Payment processing ';
    }

    return (
      <div className="cart_price_section">
        <div className="cart_prc_block">
          <div className="price_detail">
            <div className="price_desc_block">
              <h6>price details</h6>
            </div>
            <div className="price_desc_block">
              <span>Price of {totalcountEachProduct} Items</span>
              <span>₹ {totalPrice + cartProps.adminFlatDiscount || 0}</span>
            </div>
            <div className="price_desc_block">
              <span>Taxes</span>
              <span>
                ₹{' '}
                {Math.round(
                  (taxedTotalPrice - totalPrice + Number.EPSILON) * 100
                ) / 100}
              </span>
            </div>
            {cartProps.adminFlatDiscount ? (
              <div className="price_desc_block">
                <span>First purchase discount</span>
                <span>₹ {cartProps.adminFlatDiscount || 0}</span>
              </div>
            ) : null}
            <div className="price_desc_block">
              <span>Delivery charge</span>
              <span>Free</span>
            </div>
            <div className="price_desc_block total_cart_amnt">
              <span>total amount</span>
              <span>₹{taxedTotalPrice}</span>
            </div>
            {/*<div className="price_desc_block">
              <span className="amnt_saved">you save ₹0 on this order</span>
            </div>*/}
          </div>
          <button
            type="button"
            id="btn_placeorder"
            className="signup_btn"
            disabled={buttonDisabled || buttonLoading || paymentLoading}
            onClick={handleSubmitClicked}
          >
            {finalButtonText}
            {` `}
            {buttonLoading || paymentLoading ? (
              <Spinner animation="border" size="sm" variant="dark" />
            ) : null}
          </button>
          <div className="price_extra_info">
            <ul className="prc_seal">
              <li>
                <img
                  src={require('assets/images/product/price_seal1.png').default}
                  className="img-responsive"
                  alt="seal"
                />
              </li>
              <li>
                <img
                  src={require('assets/images/product/price_seal2.png').default}
                  className="img-responsive"
                  alt="seal"
                />
              </li>
              <li>
                <img
                  src={require('assets/images/product/price_seal3.png').default}
                  className="img-responsive"
                  alt="seal"
                />
              </li>
            </ul>
            <ul className="pay_mode d-flex">
              <li>
                <img
                  src={require('assets/images/visa.png').default}
                  className="img-responsive"
                  alt="visa"
                />
              </li>
              <li>
                <img
                  src={require('assets/images/mc.png').default}
                  className="img-responsive"
                  alt="mastercard"
                />
              </li>
              <li>
                <img
                  src={require('assets/images/paypal.png').default}
                  className="img-responsive"
                  alt="paypal"
                />
              </li>
              <li>
                <img
                  src={require('assets/images/amricanex.png').default}
                  className="img-responsive"
                  alt="americanex"
                />
              </li>
              <li>
                <img
                  src={require('assets/images/upi.png').default}
                  className="img-responsive"
                  alt="upi"
                />
              </li>
            </ul>
            <p>Safe and Secure Payments.</p>
            <p>Easy returns.100% Authentic products.</p>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default SummarySection;
